/**
 * @file 飞桨AI For Science共创计划
 * @author v_duzhengqiang
 */
import React from 'react';
import { Spin } from 'antd';
import classNames from 'classnames';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import Quick from '../install/pages/FastDeploy';

import EasyDeployHeader from './components/easyDeployHeader/EasyDeployHeader';
import EasyDeployFotter from './components/easyDeployFotter/EasyDeployFotter';
import EasyDeployIntro from './components/easyDeployIntro';
import EasyDeployDescribe from './components/easyDeployDescribe';
import EsayDeployQuick from './components/esayDeployQuick';
import useEasyDeployHooks from './easyDeployHooks';


const EasyDeploy: React.FC = () => {
    const { data, loading } = useEasyDeployHooks();


    return (
        <div className={classNames("easy_deploy", {
            "easy_deploy-o": loading
        })}>
            <Header />
            {loading && <div className="easy_deploy-loading">
                <Spin />
            </div>}
            <div className="easy_deploy-c">
                {/* 头部 */}
                <EasyDeployHeader {...data.easyDeployHeader} />
                <EasyDeployIntro {...data.easyDeployIntro} />
                {/* 开始安装 */}
                <EsayDeployQuick>
                    <Quick />
                </EsayDeployQuick>
                {/* 核心优势 */}
                <EasyDeployDescribe {...data.easyDeployDescribe} />
                {/* 使用咨询 */}
                <EasyDeployFotter
                    easyDeployFotter={data.easyDeployFotter}
                    qrCode={data.qrCode}
                />
            </div>
            <Footer />
        </div>
    );
};

export default React.memo(EasyDeploy);
